import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isNil, includes } from 'ramda';
import { Box, Typography } from '@material-ui/core';

import MortgageSurveyPresenter, { PURPOSE_TYPES } from 'presenters/MortgageSurveyPresenter';
import MortgageSurvey from 'sharedComponents/MortgageSurvey';
import MortgageSurveyFlowSelect from 'sharedComponents/MortgageSurveyFlowSelect';
import * as surveyQuestions from 'lib/surveys';

import useStyles from './useStyles';

const Survey = props => {
  const { onSelectFlow, selectedFlow, surveyValues, setInitialSurveyValues, removeQuoteBox } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const handleSelectFlow = value => {
    const initialValues = MortgageSurveyPresenter.buildInitialSurveyFlowValues(surveyValues, value);
    setInitialSurveyValues(initialValues);
    onSelectFlow(value);
  };

  const isNeedToSelectFlow = isNil(selectedFlow);

  if (isNeedToSelectFlow) {
    return (
      <Box className={classes.container}>
        <MortgageSurveyFlowSelect
          onSelect={handleSelectFlow}
          removeQuoteBox={removeQuoteBox}
          rowComponent={
            <Fragment>
              <Typography variant="h1" className={classes.header}>
                {t('components.NonAuthSurveyPage.Survey.header')}
                <br />
                {t('components.NonAuthSurveyPage.Survey.header2')}
              </Typography>
              {!removeQuoteBox && (
                <div>
                  <Box mt={2} />
                  <Typography variant="body1" className={classes.description}>
                    {t('components.NonAuthSurveyPage.Survey.description')}
                  </Typography>
                  <Box mt={2} />
                </div>
              )}
            </Fragment>
          }
        />
      </Box>
    );
  }

  const { questions } = includes(selectedFlow, PURPOSE_TYPES.refinance)
    ? surveyQuestions.refinanceSurvey
    : surveyQuestions.purchaseSurvey;

  return <MortgageSurvey questions={questions} onSelect={handleSelectFlow} />;
};

Survey.propTypes = {
  onSelectFlow: PropTypes.func.isRequired,
  selectedFlow: PropTypes.string,
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
  setInitialSurveyValues: PropTypes.func.isRequired,
};

Survey.defaultProps = {
  selectedFlow: null,
};

export default Survey;



// WEBPACK FOOTER //
// ./src/components/NonAuthSurveyPage/components/Survey/Survey.js